import React from "react";
import { useTranslation } from "react-i18next";

const LANGS = [
  { code: "es", label: "ES" },
  { code: "en", label: "EN" },
];

// `compact`: opt-in, por defecto false — preserva el render actual byte a byte.
// Reduce el padding horizontal interno de los botones (10px -> 4px por lado)
// solo por debajo de `sm:` (640px) — a partir de ahí vuelve al tamaño de
// siempre, igual que el resto del header público (ver PublicHeader.jsx,
// mismo patrón que `px-3 sm:px-6`/`gap-0.5 sm:gap-3` de PR #229). Así el
// escritorio (criterio 4) queda idéntico a hoy con o sin este prop.
export default function LanguageSwitcher({ className = "", compact = false }) {
  const { i18n } = useTranslation();
  const current = i18n.language?.startsWith("en") ? "en" : "es";

  return (
    <div className={`inline-flex items-center rounded-full border border-brand-edge bg-card p-0.5 text-xs font-bold ${className}`} data-testid="language-switcher">
      {LANGS.map((l) => (
        <button
          key={l.code}
          onClick={() => i18n.changeLanguage(l.code)}
          className={`rounded-full ${compact ? "px-1 sm:px-2.5 py-1" : "px-2.5 py-1"} transition-colors ${
            current === l.code ? "bg-brand-terracotta text-white dark:text-black" : "bg-brand-stone text-white dark:text-black"
          }`}
          data-testid={`language-switch-${l.code}`}
          aria-pressed={current === l.code}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
}
